import * as React from "react";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const defaultProps = {};
const checkboxClass = css({
    position: "relative",
    display: "block",
    marginTop: "10px",
    marginBottom: "10px",
    "> label": {
        minHeight: "20px",
        paddingLeft: "20px",
        marginBottom: 0,
        fontWeight: "normal",
        cursor: "pointer",
    },
    "input:disabled": {
        cursor: "not-allowed",
    },
    "input:focus": {
        outline: "thin dotted 5px auto -webkit-focus-ring-color",
        outlineOffset: "-2px",
    },
    '> label > input[type="checkbox"]': {
        position: "absolute",
        marginLeft: "-20px",
        marginTop: "4px",
    },
    'input[type="checkbox"] + input[type="checkbox"]': {
        marginTop: "-5px",
    },
});
const requiredMarkerClass = css({
    color: getThemeColorVar("negative", "default"),
    fontWeight: 600,
});
export const Checkbox = (props) => {
    return (React.createElement("div", { className: cx(checkboxClass) },
        React.createElement("label", null,
            React.createElement("input", { type: "checkbox", id: props.id, autoFocus: props.autoFocus, disabled: props.disabled, defaultChecked: props.defaultChecked, checked: props.checked, onChange: props.onChange, required: props.required }),
            props.label,
            props.required && React.createElement("span", { className: cx(requiredMarkerClass) }, " *"))));
};
Checkbox.defaultProps = defaultProps;
export default Checkbox;
//# sourceMappingURL=checkbox.js.map